export type { TopLegendFormatterType } from './TopLegend';
export { default as TopLegend } from './TopLegend';
